<template>
  <div class="cart" :class="{ 'is-active': active }">
    <transition name="animation-cart">
      <div class="cart__body" v-show="active">
        <div class="cart__close" @click="close()"></div>
        <v-cart-item v-if="Object.keys(stateCartItems).length" ref="cart-item"/>
        <div v-else class="cart__no-item">カートに商品はありません。</div>
      </div>
    </transition>

    <div class="cart__button" @click="buttonClick()">
      <img class="cart__icon" src="/choice/img/icon/cart.svg" alt="">
      <v-cart-total-price/>
    </div>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-cart-item': require('@/components/cart-item.vue').default,
    'v-cart-total-price': require('@/components/cart-total-price.vue').default,
  },
  computed: {
    ...mapState({
      stateCartItems: state => state.cart.items,
    }),
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    buttonClick() {
      this.active = !this.active
    },
    close() {
      this.active = false
    },
  },
}
</script>



<style lang="scss">
.cart {
  $e: &;
  overflow: hidden;
  transition: $transition;
  position: relative;
  border-radius: 30px;

  &::before {
    content: "";
    transition: $transition;
    opacity: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    border-radius: 30px;
    background-color: #fff;
    width: 100%;
    height: 0;
  }

  &.is-active {
    &::before {
      opacity: 1;
      width: 100%;
      height: 100%;
    }
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    &::before,
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: #000;
      width: 16px;
      height: 1px;
    }
    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
  &__body {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 2;
    padding: 40px 40px 4px 40px;
  }
  &__no-item {
    writing-mode: vertical-lr;
    font-family: $serif;
    font-size: 13px;
    letter-spacing: 0.2em;
    text-align: justify-all;
    text-align-last: justify;
    text-justify: inter-ideograph;
    text-transform: full-width;
    text-orientation: upright;
    height: 256px;
  }
  &__list {
  }
  &__button {
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: $transition;
    user-select: none;
    position: relative;
    z-index: 2;
    border-radius: 30px;
    background-color: #fff;
    height: 60px;
    padding-left: 28px;
    padding-right: 28px;
  }
  &__icon {
    display: block;
    width: 28px;
  }

  .cart-total-price {
    margin-left: 24px;
  }
}
</style>
